// PDFファイルを生成してダウンロードする
export const downloadPdfFile = async (data: Blob, filename: string) => {
    const blob = new Blob([data], { type: "application/pdf" })
    const link = document.createElement("a")
    link.href = URL.createObjectURL(blob)
    link.download = filename
    link.click()
    URL.revokeObjectURL(link.href)
}

// PDFファイルを新しいタブで開く
export const openPdfFileInNewTab = async (data: Blob) => {
    const blob = new Blob([data], { type: "application/pdf" })
    const fileUrl = URL.createObjectURL(blob)

    if (
        navigator.userAgent.includes("Chrome") ||
        navigator.userAgent.includes("Firefox")
    ) {
        const w = window.open(fileUrl, "_blank")
        w?.focus()
    } else {
        // Safari & Opera iOS
        window.location.href = fileUrl
    }
}

// Blobをbase64に変換する
export const blobToBase64 = (
    blob: Blob
): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsDataURL(blob)
    })
}
